import ComboBoxFindTerm from "./ComboBoxFindTerm";

export default ComboBoxFindTerm;
